var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-main',[_c('wzvz_overview_all',{attrs:{"filter":_vm.filter}})],1),_c('navBar',{attrs:{"title":"Ares - Main menu","home":true,"type":"main"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }